export default __webpack_public_path__ + "static/media/searching-girl.a552aeeb.svg";